import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { GeneralLedgerState } from '../../../../../state/GeneralLedgerState/GeneralLedger.state';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GlUniqueNameValidator implements AsyncValidator {
  constructor(private store: Store) {}

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return this.store.selectOnce(GeneralLedgerState.doesNameExist(control.value)).pipe(
      map(result => {
        if (result.Result && !result.IsCurrentConfig) {
          return { duplicateName: true };
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }
}
